import { QuestionType } from '@/constants'
import { ClientPageComment, ClientPageScore, ContentQuestion, ScorePayload } from '@/types'

export default class ClientPageMapper {
  static contentQuestionsToQuestions(
    content: ContentQuestion[],
  ): Array<ClientPageScore | ClientPageComment> {
    if (!content) {
      return []
    }

    return content.map(({ type, toggle, question, required }) => {
      switch (type) {
        case QuestionType.SCORE_TYPE_SATISFACTION:
        case QuestionType.SCORE_TYPE_RECOMMENDATION:
          return {
            question,
            type,
            ...(toggle !== undefined && { includedInCarrierScore: toggle }),
            note: -1,
            required,
          } as ClientPageScore
        case QuestionType.CUSTOM:
          return {
            type,
            question,
            answer: '',
            required,
          } as ClientPageComment
      }
    })
  }

  static questionsToPayload(questions: Array<ClientPageScore | ClientPageComment>): ScorePayload {
    const result: ScorePayload = {
      score: [],
      comment: [],
    }

    if (!questions.length) {
      return result
    }

    result.comment = this._filterAndClean(questions, QuestionType.CUSTOM) as Array<
      Omit<ClientPageComment, 'type' | 'required'>
    >
    result.score = [
      ...(this._filterAndClean(questions, QuestionType.SCORE_TYPE_RECOMMENDATION) as Array<
        Omit<ClientPageScore, 'required'>
      >),
      ...(this._filterAndClean(questions, QuestionType.SCORE_TYPE_SATISFACTION) as Array<
        Omit<ClientPageScore, 'required'>
      >),
    ]

    if (!result.score.length) {
      delete result.score
    }

    if (!result.comment.length) {
      delete result.comment
    }

    return result
  }

  private static _filterAndClean(
    array: Array<ClientPageScore | ClientPageComment>,
    questionType: QuestionType,
  ) {
    return array
      .filter(({ type }) => type === questionType)
      .map(item => {
        switch (item.type) {
          case QuestionType.SCORE_TYPE_SATISFACTION:
          case QuestionType.SCORE_TYPE_RECOMMENDATION:
            const {
              type,
              note,
              includedInCarrierScore,
              question: scoreQuestion,
            } = item as ClientPageScore

            return {
              type,
              question: scoreQuestion,
              ...(includedInCarrierScore !== undefined && { includedInCarrierScore }),
              note: note === -1 ? null : note,
            } as ClientPageScore
          case QuestionType.CUSTOM:
            const { question, answer } = item as ClientPageComment

            return {
              question,
              answer,
            } as ClientPageComment
        }
      })
  }
}
